import { CaretLeft } from "@phosphor-icons/react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import {
  ContentContainer,
  ContentHeader,
  ContentScroll,
  PageTitle,
} from "features/layout/components";

import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import { Button } from "common/components/ui/Button";
import { Dialog, OverlayDialogContent } from "common/components/ui/Dialog";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useLead from "../../datahooks/useLead";
import DesktopLeadDetails from "./DesktopLayout/DesktopLeadDetails";
import MobileLayout from "./MobileLayout";

import type { ReactNode } from "react";

export default function LeadDetails() {
  const isDesktop = useTwBreakpoint("lg");
  const navigate = useNavigate();

  const { profileId } = useParams();
  const { state } = useLocation();
  const { lead, refetchLead, leadError, isLoadingLead } = useLead({
    profileId,
    placeholderLead: state?.lead,
  });

  let mainContent: ReactNode;

  if (leadError) {
    mainContent = (
      <ErrorPlaceholder
        errorMessage="Could not display Leads Data"
        onRetry={refetchLead}
      />
    );
  } else {
    mainContent = isDesktop ? (
      <DesktopLeadDetails
        profileId={profileId}
        lead={lead}
        isLoading={isLoadingLead}
      />
    ) : (
      <MobileLayout
        profileId={profileId}
        lead={lead}
        isLoading={isLoadingLead}
      />
    );
  }

  if (isDesktop) {
    return (
      <ContentContainer>
        <ContentHeader>
          <div className="flex gap-x-1.5 items-center">
            <Button asChild intent="iconOnly" variant="ghost-black" size="xs">
              <Link to="..">
                <CaretLeft />
              </Link>
            </Button>
            <PageTitle>
              {lead ? `${lead.full_name}'s profile` : "Lead profile"}
            </PageTitle>
          </div>
        </ContentHeader>
        <ContentScroll className="p-4">{mainContent}</ContentScroll>
      </ContentContainer>
    );
  }
  return (
    <Dialog
      open
      onOpenChange={(open) => {
        if (!open) {
          navigate(-1);
        }
      }}
    >
      <OverlayDialogContent>{mainContent}</OverlayDialogContent>
    </Dialog>
  );
}
